<template>
<Dialog v-model:visible="showmodal" modal  :style="{ width: '50rem' }">
 <template #header>
 	<h4 class="text-primary">Uygunsuzluk Red Sebebi</h4>
</template>



<div class="grid">
<div class="col-12">
<Textarea v-model="rejectionreason" rows="5" class="w-full" placeholder="En az 10 karakter"/>
</div>
<div class="col-12 flex justify-content-end">
<Button  icon="pi pi-times" :label="$store.state.languages.lang_phrases.iptal" @click="closeModal" class=" p-button-danger p-button-outlined  p-button-sm" /> 
<Button  icon="pi pi-check"  :label="$store.state.languages.lang_phrases.kaydet" @click="resolveNonconformity" class=" p-button-primary p-button-outlined  p-button-sm ml-2 " :loading="loading" :disabled="rejectionreason.length<10"/> 

</div>

</div>
</Dialog>
</template>

<script>
export default {

  name: 'NonconformityRejectionModal',
  data () {
    return {
    	showmodal:false,
    	rejectionreason:"",
    	loading:false,
      revising:false,
      request:null,
    }
  },
  methods:{
  	closeModal()
    {
      this.rejectionreason = ""
      this.showmodal = false
      this.revising = false
    },
    openModal()
    {
      this.showmodal = true
    },    
    reviseRejectionText(item)
    {
      this.rejectionreason = item.rejectiontext
      this.revising = true
      this.request = item
      this.showmodal = true
    },
  	resolveNonconformity()
  	{
  		let formdata = new FormData()
      formdata.append("type","false")
      formdata.append("reason",this.rejectionreason)
      if(this.revising)
      {
        this.generalSubmission(formdata,"revise_nonconformity/"+this.request.id,this.afterSubmit)
      }
      else
      {
        this.generalSubmission(formdata,"resolve_nonconformity/"+this.$route.params.nonconformity_id,this.afterSubmit)
      }
      
  		console.log(this.$route.params)
  	},
  	afterSubmit(response)
  	{
      this.closeModal()
  		this.$emit("nonconformityRejected",response)
  	},
  },
}
</script>

<style lang="css" scoped>
</style>